import { SearchQuery } from "shared/data/reducers/types/storage";

const TRANSFER_AIRPORT_FILTER_PATTERN = /^airports_(?:\d+_)?transfers$/;

export const removeTransferAirportFilters = (
  searchQuery: SearchQuery
): SearchQuery => {
  const queryWithoutTransferAirports = { ...searchQuery };

  Object.keys(queryWithoutTransferAirports).forEach((key) => {
    if (TRANSFER_AIRPORT_FILTER_PATTERN.test(key)) {
      delete queryWithoutTransferAirports[key];
    }
  });

  return queryWithoutTransferAirports;
};
